import { render } from "./PanelTopDownCartoes.vue?vue&type=template&id=5c1d94f6&scoped=true"
import script from "./PanelTopDownCartoes.vue?vue&type=script&lang=js"
export * from "./PanelTopDownCartoes.vue?vue&type=script&lang=js"

import "./PanelTopDownCartoes.vue?vue&type=style&index=0&id=5c1d94f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c1d94f6"]])

export default __exports__